// extracted by mini-css-extract-plugin
export default {"submenuContainer":"MenuItemContainer-module--submenuContainer--e7d66","dropDown":"MenuItemContainer-module--dropDown--0c4f1"};